module.exports = __webpack_public_path__ + "static/media/calc.fcd78440.svg";